/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function ArrowCurveBackUp({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 12" {...props}><path fill="#666260" fillRule="evenodd" d="M11.2 10.6a.6.6 0 0 1-.6.6h-4A3.6 3.6 0 0 1 3 7.6V2.049L1.024 4.024a.6.6 0 1 1-.848-.848l3-3a.6.6 0 0 1 .848 0l3 3a.6.6 0 0 1-.848.848L4.2 2.05V7.6A2.4 2.4 0 0 0 6.6 10h4a.6.6 0 0 1 .6.6" clipRule="evenodd" /></svg>;
}
;